import React, { FC } from 'react'
import { Alert, Grid } from '@mui/material'
import { ContractorPicker, ContractorSummaryCard, WizardFooter } from './wizardParts'
import { getTargetEligibility, TransferWizardAction, TransferWizardState, TransferWizardStep } from './transferWizardHelpers'

interface ContractorsStepProps {
  state: TransferWizardState
  dispatch: (action: TransferWizardAction) => void
}

/** Step 1: the source and the target, any two different contractors; a deactivated target cannot be picked. */
export const ContractorsStep: FC<ContractorsStepProps> = ({ state, dispatch }) => {
  const { source, target } = state
  const eligibility = target ? getTargetEligibility(target, source?.id) : null

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <ContractorPicker label="Source contractor" value={source} onChange={(contractor) => dispatch({ type: 'setSource', contractor })} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ContractorPicker
            label="Target contractor"
            value={target}
            onChange={(contractor) => dispatch({ type: 'setTarget', contractor })}
            getOptionDisabledReason={(contractor) => getTargetEligibility(contractor, source?.id).reason}
          />
        </Grid>
        {source && (
          <Grid item xs={12} sm={6}>
            <ContractorSummaryCard title="Source" contractor={source} />
          </Grid>
        )}
        {target && (
          <Grid item xs={12} sm={6} {...(!source ? { sx: { ml: { sm: 'auto' } } } : {})}>
            <ContractorSummaryCard title="Target" contractor={target} />
            {eligibility?.reason && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {`This contractor cannot be the target: ${eligibility.reason.toLowerCase()}.`}
              </Alert>
            )}
            {eligibility?.warning && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                {eligibility.warning}
              </Alert>
            )}
          </Grid>
        )}
      </Grid>
      <WizardFooter
        hint="Users keep their role at the target. Everything else follows the rules of the transfer and is shown on the summary before it runs."
        nextDisabled={!source || !target || !eligibility?.selectable}
        onNext={() => dispatch({ type: 'goTo', step: TransferWizardStep.Users })}
      />
    </>
  )
}
